import { render, staticRenderFns } from "./CloneForm.vue?vue&type=template&id=0bfee3dc&"
import script from "./CloneForm.vue?vue&type=script&lang=js&"
export * from "./CloneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports